module.exports = __webpack_public_path__ + "static/media/Account_created.2e3fd04c.svg";